import { useEffect, useState } from 'react'

// local imports
import DateUtil from 'utils/DateUtil'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import CoiffeurSearchModal from 'components/home/on-campus-services/coiffeur/coiffeur-search-modal/CoiffeurSearchModal'
import useGetCoiffeurSalonList from 'components/home/on-campus-services/coiffeur/hooks/use-get-coiffeur-salon-list'
import LoadingWrapper from './LoadingWrapper'

/* Constants & Types */
const today = DateUtil.getStartOfDay(new Date())
interface CompProps {
  locationId: number
  id: number
  setReservationType: (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => void
}

export default function CoiffeurRes({ id, locationId, setReservationType }: CompProps) {
  const [formModal, setFormModal] = useState(false)
  const [showFormModal, setShowFormModal] = useState(false)
  const openFormModal = () => {
    setFormModal(true)
    setShowFormModal(true)
  }
  const closeFormModal = () => {
    setFormModal(false)
    setShowFormModal(false)
    setReservationType(0, undefined)()
  }

  /* Get Coiffeur Salon List Get Coiffeur Salon Specialties - Locations | Custom Hooks */
  const { getSalonList, coiffeurSalons, loading } = useGetCoiffeurSalonList()
  const selectedSalon = coiffeurSalons.find((r) => r.id === id)
  useEffect(() => {
    getSalonList({ LocationIds: [locationId], ReservationDate: today, IsOnlyUserGender: true })
    openFormModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, locationId])

  if (loading) return <LoadingWrapper />

  return (
    <>
      {showFormModal && !!selectedSalon ? (
        <CoiffeurSearchModal
          cancelClose={closeFormModal}
          filteredDate={today}
          salon={selectedSalon}
          formModal={formModal}
          setFormModal={setFormModal}
          setShowModal={setShowFormModal}
        />
      ) : null}
    </>
  )
}
